import React, { useState, useEffect, useRef, createRef } from "react";
import {
  CardContent,
  CardActions,
  Grid,
  TextField,
  Box,
  Typography,
  FormControlLabel,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from "@material-ui/core";
import { ErrorMessage, Form, Formik } from "formik";
import { useSnackbar } from "notistack";
import Card from "../../../../components/Card";

import { makeStyles } from "@material-ui/core/styles";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import ButtonWithLoading from "../../../../components/ButtonWithLoading";
import { FormLoader } from "../../../../components/FormLoader";

import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Get, Create } from "../../../../actions";
import {
  GET_AllContactList_URL,
  Get_AllManagementCompanyFeeServicesByType_URL,
  GET_AllUsersWithoutAuthorization_URL,
  Post_AddNewFileCircularResolution_URL,
  Get_CircularResolutionsTemplates_URL,
  Get_AllCeresServices_URL,
  Get_MCShareholders_URL,
  Get_MCBoardMembers_URL,
} from "../../../../constants/apiUrls";
import { DatePicker } from "../../../../components/DatePicker";

import { UploadFiles } from "../../../../components/Upload";
import { ClassicTextEditor } from "../../../../components/TextEditor";
import { SelectMember } from "./components/SelectMembers";
import { Notifyee } from "./components/notifyee";
import { LanguageSelection } from "../../../../constants/languages";
import { getTranslation } from "../../../../heplers/translationHelper";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import TableComponent from "../../../../components/table";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "16px",
    marginLeft: "10px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  card: {
    marginTop: "30px",
  },
}));

const columns = [
  {
    id: "fullName",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Name", "Nom", "Name"),
  },
  {
    id: "mail",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Email", "E-mail", "Email"),
  },
  {
    id:"Type",
    label:getTranslation("Type"),
    component:({row})=><Typography>{row.representativeRole?"Board":"Shareholder"}</Typography>

  }
 
];

const GenerateCircularResolution = ({ managementCompanyId, isSubmitting, onGenerate }) => {
  const [contactListLoading, setContactListLoading] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [usersList, setusersList] = useState([]);
  const [ceresServices, setCeresServices] = useState([]);
  const [ceresServicesLoading, setCeresServicesLoading] = useState(false);
  const [circularResolutionFiles, setCircularResolutionFiles] = useState();
  const [boardList, setBoardList] = useState([]);
  const [shareList, setShareList] = useState([]);


  ////////// template setting states ////////////
  const [templateList, setTemplateList] = useState([]);
  const [templateListLoading, setTemplateListLoading] = useState(false);
  const [enableReloading, setEnableReloading] = useState(false);
  const history = useNavigate();
  const dispatch = useDispatch();
  const filter = createFilterOptions();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [resolutionText, setResolutionText] = useState("<p>first</p>");

  /////////////// get user without authorization ///////////////

  useEffect(() => {
    loadUsersWithoutAuth();
    loadMCBoardMembers();
    loadMCShareholders();
  }, []);
  const loadUsersWithoutAuth = (values) => {
    Get(
      values,
      GET_AllUsersWithoutAuthorization_URL,
      null,
      (resp) => {
        setusersList(resp?.data);
      },
      (error) => {}
    );
  };

  useEffect(() => {
    setContactListLoading(true);
    Get(
      {},
      GET_AllContactList_URL,
      history,
      (resp) => {
        setContactList(resp.data);
        setContactListLoading(false);
      },
      (error) => {}
    );
  }, []);

  const loadCeresServices = async () => {
    setCeresServicesLoading(true);

    await Get(
      {
        id: managementCompanyId,
        feeType: 0,
      },
      Get_AllManagementCompanyFeeServicesByType_URL,
      history,
      (resp) => {
        setCeresServices(resp.data);
        setCeresServicesLoading(false);
      },
      (error) => {
        setCeresServicesLoading(false);
      }
    );
  };

  useEffect(() => {
    loadCeresServices();
  }, []);

  const addNewCircularResolutionFile = (fileAddress) => {
    Create(
      {
        fileName: fileAddress,
        circularResolutionId: "8c075093-96a8-4563-a38e-08d996205ca3",
      },
      Post_AddNewFileCircularResolution_URL,
      null,
      (resp) => {
        //setCircularResolutionFiles([...circularResolutionFiles,files])
      },
      (error) => {}
    );
  };

  /////////////////// Load Templates ///////////////
  const loadTemplates = (language) => {
    Get(
      { language: language },
      Get_CircularResolutionsTemplates_URL,
      null,
      (resp) => {
        setTemplateList(resp?.data);
      },
      (error) => {
      }
    );
  };


  
    ///////////////// Board Members ////////////////////
    const loadMCBoardMembers = () => {
     
      // setMembersLoading(true);
      Get(
        { MCid: managementCompanyId },
        Get_MCBoardMembers_URL,
        null,
        (resp) => {
          // setMembersLoading(false);
          setBoardList(resp?.data);
          
        },
        (error) => {
          // setMembersLoading(false);
          enqueueSnackbar(error?.data, { variant: "error" });
        }
      );

    };

      ///////////////// Shareholder Members ////////////////////
  const loadMCShareholders = () => {

    Get(
      { MCid: managementCompanyId },
      Get_MCShareholders_URL,
      null,
      (resp) => {
        // setMembersLoading(false);
        console.log("lkjashdlkjashdlkjahd",resp.data)
        setShareList(resp?.data);

      },
      (error) => {
        // setMembersLoading(false);
        enqueueSnackbar(error?.data, { variant: "error" });
      }
    );
  };

  const getMembers=(decisionMakerType)=>{
    console.log("kjalsdkalshdlakshda",decisionMakerType)
    if (decisionMakerType == "all") return [...boardList, ...shareList];
    else if (decisionMakerType == "board") return [...boardList];
    else if(decisionMakerType == "shareholder") return [...shareList]
    else 
    return [];
  }


  const initialValues = {
    subject: "",
    resolution: "",
    deadline: new Date(),
    language: "French",
    personInchargeId: "",
    sponsorId: 0,
    managementCompanyId: managementCompanyId,
    companyCeresServiceId: 0,
    members: [],
    files: [],
    notifyeesList: [],
    decisionMakerType:"all",

    // for Generate only

    sponsor: null,
    companyCeresService: {},
    personIncharge: null,
    selectedBoardMembers: [],
    selectedShareholders: [],
    selectedManagers: [],
    selectedDecisionMakers: [],
    template: "",
  };

  const basicValidationSchema = Yup.object().shape({
    subject: Yup.string().required("Subject is required"),
    resolution: Yup.string().required("Resolution is required"),
    language: Yup.string().required("Language is required"),
    personInchargeId: Yup.string().required("Person Incharge is required"),
    sponsorId: Yup.number()
      .min(1, "SponserId must be greater than 1")
      .required("Sponser is required"),
    companyCeresServiceId: Yup.number().min(0)
      .required("Company Ceres Service Id is required"),
    
  });


  const errorDivRef = createRef();
  return (
    <FormLoader>
      <Formik
          //enableReinitialize
          initialValues={initialValues}
          validationSchema={basicValidationSchema}
          onSubmit={(values, actions) => {
            actions.setSubmitting(true);
            // values.selectedDecisionMakers.forEach((decisionMaker) => {
            //   const index = values.members.findIndex(
            //     (x) => x.id === decisionMaker.id
            //   );
            //   values.members[index].isDescisionMaker = true;
            // });
            const arr = [];
            values.notifyeesList.forEach((notify) => {
              arr.push(notify.id);
            });
            values.notifyeesList = arr;
            onGenerate(values, actions);
            // actions.resetForm();
          }}
        >
          {({
            errors,
            touched,
            values,
            handleSubmit,
            getFieldProps,
            setFieldValue,
            handleChange,
          }) => (
            <Form>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Autocomplete
                      id="companyCeresServiceId"
                      name="companyCeresServiceId"
                      value={values.companyCeresService}
                      options={ceresServices}
                      getOptionLabel={(option) => option.ceresServiceTitle}
                      size="small"
                      onChange={(e, value) => {
                        console.log("kjfkjdskfdsf",value);
                        setFieldValue("companyCeresServiceId", value?.id);
                        setFieldValue("companyCeresService", value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={getTranslation("Ceres Service","Service Cérès","Ceres-Dienst")}
                          variant="outlined"
                          required
                          error={
                            touched.companyCeresServiceId &&
                            Boolean(errors.companyCeresServiceId)
                          }
                          helperText={
                            touched.companyCeresServiceId &&
                            errors.companyCeresServiceId
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <LanguageSelection
                      label={getTranslation("Language","Langue","Sprache")}
                      name="language"
                      id="language"
                      required
                      onChange={(e, value) => {
                        setFieldValue("language", value);
                        loadTemplates(value);
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <Autocomplete
                      name="template"
                      options={templateList}
                      getOptionLabel={(option) => option.title}
                      size="small"
                      onChange={(e, value) => {
                        setFieldValue("template", value?.id);
                        setFieldValue("resolution", value?.resolution);
                        setResolutionText("<p>Asghar hello</p>");
                        setEnableReloading(true);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={getTranslation("Template","Modèle","Vorlage")}
                          variant="outlined"
                          error={touched.template && Boolean(errors.template)}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <TextField
                      fullWidth
                      id="subject"
                      label={getTranslation("Subject","Sujette","Fach")}
                      required
                      size="small"
                      variant="outlined"
                      name="subject"
                      {...getFieldProps("subject")}
                      error={touched.subject && Boolean(errors.subject)}
                      helperText={touched.subject && errors.subject}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                 

                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <Autocomplete
                      options={contactList}
                      value={values.sponsor}
                      getOptionLabel={(option) => option.fullName}
                      size="small"
                      onChange={(e, value) => {
                        setFieldValue("sponsorId", value?.id);
                        setFieldValue("sponsor", value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={getTranslation("Sponser","Parrain","Sponsor")}
                          variant="outlined"
                          error={touched.sponsorId && Boolean(errors.sponsorId)}
                          helperText={touched.sponsorId && errors.sponsorId}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <Autocomplete
                      options={usersList}
                      value={values.personIncharge}
                      getOptionLabel={(option) => option.name}
                      size="small"
                      onChange={(e, value) => {
                        setFieldValue("personInchargeId", value?.id);
                        setFieldValue("personIncharge", value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={getTranslation("Person Incharge","Personne en charge","Verantwortlicher")}
                          variant="outlined"
                          error={
                            touched.personInchargeId &&
                            Boolean(errors.personInchargeId)
                          }
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <DatePicker
                    fullWidth
                      id="deadline"
                      label={getTranslation("Deadline","Date limite","Termin")}
                      value={values.deadline}
                      onChange={(value) => {
                        setFieldValue("deadline", value);
                      }}
                      required
                      error={touched.deadline && Boolean(errors.deadline)}
                    />
                  </Grid>
                </Grid>
               
                <Card title={getTranslation("Decision Makers","Décideurs","Entscheidungsträger")} className={classes.card}>
                  <CardContent>
                  <Box display="flex" justifyContent="center">
                  <ToggleButtonGroup exclusive value={values.decisionMakerType} style={{ marginLeft: "20px" }} onChange={(e,value)=>setFieldValue("decisionMakerType",value)}>
                    <ToggleButton value="all">All</ToggleButton>
                    <ToggleButton value="board">Board</ToggleButton>
                    <ToggleButton value="shareholder">Shareholder</ToggleButton>
                  </ToggleButtonGroup>
                  </Box>
              <br />
              <br />
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Table>
                  <TableHead>
                    <TableRow>
                      
                      <TableCell>
                      <Typography> Full Name</Typography> 
                      </TableCell>
                      <TableCell>
                        Email
                      </TableCell>
                      <TableCell>
                        Type
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getMembers(values.decisionMakerType)?.map(member=> <TableRow>
                      <TableCell>
                        {member.fullName}
                      </TableCell>
                      <TableCell>
                        {member.mail}
                      </TableCell>
                      <TableCell>
                        {member.representativeRole?"Board":"Shareholder"}
                      </TableCell>
</TableRow>)}
                   
                  </TableBody>
                </Table>
              
                {/* <SelectDecisionMember
                  options={circularResolutionMembers}
                  circularResolutionId={circularResolutionId}
                  isApproved={circularResolution?.status}
                /> */}
              </Grid>
                  </CardContent>
                </Card>

                <Card className={classes.card} title={getTranslation("Notifyees","Notifiés","Benachrichtigte")} >
                  <CardContent>
                    <Notifyee
                      contactList={contactList}
                      onPersonChanged={(persons) => {
                        setFieldValue("notifyeesList", persons);
                      }}
                    />
                  </CardContent>
                </Card>
                <Card title={getTranslation("Upload Documents","Télécharger des documents","Dokumente hochladen")} className={classes.card}>
                  <CardContent>
                    <UploadFiles
                      uploadedFiles={values.files}
                      getFileName={(x) => x.fileName}
                      // files={}
                      // onFilesChanged={(files) => {
                      //   setFieldValue("files", files);
                      // }}
                      onAddFile={(file) => {
                        setFieldValue("files", [
                          ...values.files,
                          { fileName: file },
                        ]);
                      }}
                      onDeleteFile={(file) => {
                        setFieldValue(
                          "files",
                          values.files.filter(
                            (x) => x.fileAddress != file.fileAddress
                          )
                        );
                      }}
                    />
                  </CardContent>
                </Card>
                <ClassicTextEditor
                    text={values.resolution}
                    onChange={(text) => {
                      setFieldValue("resolution", text);
                      // if (Object.keys(errors).length > 0) {
                      //   enqueueSnackbar("Some fields are missing.", {
                      //     variant: "error",
                      //   });
                      // }
                      handleSubmit();
                    }}
                    showButton
                  />
                <br />
                <br />
              </CardContent>
              
            </Form>
          )}
        </Formik>
    </FormLoader>
  );
};

export default GenerateCircularResolution;
